import { useEffect, useRef } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { NOTIFICATION_ADDED_EVENT } from './model/constants';
import {
  markSeen,
  notificationDuration,
  notificationId,
  notificationImage,
  notificationLink,
  notificationText,
  notificationTitle,
  wasSeen
} from './model/utils';

const ToastContent = ({ notification }) => {
  const title = notificationTitle(notification);
  const text = notificationText(notification);
  const link = notificationLink(notification);
  const image = notificationImage(notification);

  return (
    <div>
      <div
        style={{
          fontWeight: 600,
          fontSize: 14,
          lineHeight: 1.4,
          wordBreak: 'break-word',
          marginBottom: 6
        }}
      >
        {title}
      </div>
      {image && (
        <img
          src={image}
          alt=""
          style={{ width: 'calc(100% + 24px)', margin: '0 -12px', display: 'block' }}
        />
      )}
      {(text || link) && (
        <div
          style={{
            marginTop: 8,
            fontSize: 13,
            lineHeight: 1.5,
            color: '#374151',
            wordBreak: 'break-word'
          }}
        >
          {/* eslint-disable-next-line react/no-danger */}
          {text && <div dangerouslySetInnerHTML={{ __html: text }} />}
          {link && (
            <a
              href={link}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'inline-block',
                marginTop: 6,
                fontSize: 13,
                fontWeight: 500,
                color: '#2563eb',
                textDecoration: 'none'
              }}
            >
              Open link &#x2192;
            </a>
          )}
        </div>
      )}
    </div>
  );
};

const NotificationToast = () => {
  const shownRef = useRef(new Set());

  useEffect(() => {
    const onAdded = (event) => {
      const notification = event.detail?.notification;
      if (!notification) return;
      const id = notificationId(notification);
      if (id == null || wasSeen(id) || shownRef.current.has(id)) return;

      shownRef.current.add(id);
      const duration = notificationDuration(notification);

      toast(<ToastContent notification={notification} />, {
        toastId: id,
        autoClose: duration > 0 ? duration : false,
        closeOnClick: false,
        onClose: () => {
          markSeen(id);
          shownRef.current.delete(id);
        },
        style: { padding: '8px 12px', borderRadius: 12 }
      });
    };

    window.addEventListener(NOTIFICATION_ADDED_EVENT, onAdded);
    return () => window.removeEventListener(NOTIFICATION_ADDED_EVENT, onAdded);
  }, []);

  return (
    <ToastContainer
      position="top-right"
      newestOnTop
      draggable={false}
      pauseOnHover
      limit={5}
      style={{ zIndex: 100001 }}
    />
  );
};

export default NotificationToast;
